import { FC, ReactNode } from 'react'
import { Button, Paper, Stack, Typography } from '@mui/material'
import { FirefoxIcon, GoogleChromeIcon, HelpIcon, Logotype } from 'apps/doctor/src/assets/icons'
import clsx from 'clsx'
import { useAppDispatch } from '../../../store'
import makeStyle from './_style'
import { chromeLink, firefoxLink } from '../../../utils/links'
import { logoutUser } from '../../../redux/actions'
import { localStorageManager } from '../../../utils/LocalStorageManager'
import CardButton from '../../common/cardButton/CardButton'

export const OrdoclicSafariGuard: FC<{ children: ReactNode }> = ({ children }) => {
    const dispatch = useAppDispatch()
    const style = makeStyle()
    const isSafari = /^((?!chrome|chromium|edg|opr).)*safari/i.test(navigator.userAgent)

    if (!isSafari) return children

    const handleLogout = () => {
        dispatch(logoutUser())
        localStorageManager.clear()
        const hds = window._env_.REACT_APP_HDS_HOST
        const auth = window._env_.REACT_APP_CUR_AUTH_CLBC
        window.location.href = `${hds}/login?redirect=${auth}`
    }

    return (
        <div className={clsx(style.container)} data-testid="safari-guard">
            <Paper elevation={6} className={clsx(style.main)}>
                <Logotype className={clsx(style.logo)} />
                <Stack gap="1.5rem">
                    <Stack alignItems="center">
                        <Typography textAlign="center" className={clsx(style.title)}>
                            Votre navigateur Safari n’est plus supporté par TokTokDoc
                        </Typography>
                        <Typography textAlign="center" className={clsx(style.text)}>
                            Le nouveau module de prescription n’est pas encore compatible avec Safari. Pour une
                            expérience optimale, nous vous recommandons l’un des navigateurs suivants :
                        </Typography>
                    </Stack>
                    <Stack direction="row" className={clsx(style.icons)}>
                        <CardButton
                            label="Installer Chrome"
                            icon={<GoogleChromeIcon />}
                            onClick={() => window.open(chromeLink)}
                        />
                        <CardButton
                            label="Installer Firefox"
                            icon={<FirefoxIcon />}
                            onClick={() => window.open(firefoxLink)}
                        />
                    </Stack>
                </Stack>
                <Typography textAlign="center" className={clsx(style.text)}>
                    Ensuite, reconnectez-vous à votre compte depuis votre nouveau navigateur.
                </Typography>
                <Button onClick={handleLogout} className={clsx(style.logoutButton)}>
                    Se déconnecter
                </Button>
            </Paper>
            <Stack className={clsx(style.footer)}>
                <div className={clsx(style.footerLogoWrapper)}>
                    <HelpIcon />
                </div>

                <Typography className={clsx(style.footerText)}>
                    Assistance disponible au <a href="tel:0188328491">01 88 32 84 91</a>
                </Typography>
            </Stack>
        </div>
    )
}
